import React, { PureComponent } from 'react';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import { Grid, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

import { CONNECTION_CATEGORY_SOAP } from 'js/constants/connectionCategories';
import ConfigurationFields from '../../../elements/configViews/ConfigurationFields';

class SOAPSourceConfiguration extends PureComponent {
  render() {
    const {
      data: { source_config },
    } = this.props;
    const params = source_config && source_config['soap.params'];

    return (
      <div>
        <ConfigurationFields {...this.props} connectionCategory={CONNECTION_CATEGORY_SOAP} />
        {!isEmpty(params) && (
          <div className="details-accordion-group">
            <Accordion className="accordion-item" key={1} defaultExpanded>
              <AccordionSummary
                className="accordion-title"
                expandIcon={<ExpandMore fontSize="large" />}
              >
                <div className="accordion-title-content">
                  <h2>Operation parameters and values</h2>
                  <span className="toggle-text">Click to expand/collapse</span>
                </div>
              </AccordionSummary>
              <AccordionDetails className="accordion-body">
                <div className="accordion-body-content">
                  <div className={'full-width-table'}>
                    <div className="table-header">
                      <Grid container className="table-header-row">
                        <Grid item xs={6}>
                          Parameter
                        </Grid>
                        <Grid item xs={6}>
                          Value
                        </Grid>
                      </Grid>
                    </div>
                    <div fluid={true} className={'table-body'}>
                      {map(params, (value, key) => {
                        return (
                          <div key={key} className="table-body-row">
                            <Grid item xs={6}>
                              {key}
                            </Grid>
                            <Grid item xs={6}>
                              {value}
                            </Grid>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
        )}
      </div>
    );
  }
}

export default SOAPSourceConfiguration;
